import(/* webpackMode: "eager" */ "/app/src/app/(ru)/error.tsx");
